import { createSlice, current } from '@reduxjs/toolkit';
import { create, updateUser, getUsers, deleteUsers, disableUsers, enableUsers } from '../../thunks/admin/users';
import { mergeArrayByKey } from '../../../utils/helpers/data';

export const usersSlice = createSlice({
  name: 'users',
  initialState: {
    users: [],
    currentPage: 1,
    limit: 30,
    totalDocs: 0,

    isCreating: false,
    isUpdating: {},
    isFetching: false,
  },

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getUsers.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getUsers.fulfilled]: (state, action) => {
      const { users, totalDocs } = action.payload;

      state.totalDocs = totalDocs;
      
      const currentState = current(state);
      state.users = currentState.currentPage === 1 ? [...users] : mergeArrayByKey([...currentState.users, ...users], '_id');
    
      state.isFetching = false;
    },
    [getUsers.rejected]: (state, action) => {
      const currentState = current(state);
      if (currentState.currentPage === 1) {
        state.users = [];
        state.totalDocs = 0;
      }
      state.isFetching = false;
    },
    
    [create.pending]: (state, action) => {
      state.isCreating = true;
    },
    [create.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.users.push(action.payload);
      state.totalDocs = currentState.totalDocs + 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      state.isCreating = false;
    },
    [create.rejected]: (state, action) => {
      state.isCreating = false;
    },

    [updateUser.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = true;
    },
    [updateUser.fulfilled]: (state, action) => {
      const currentState = current(state);
      const updatedUser = action.payload;
      state.users = currentState.users.map(user => user._id === updatedUser._id ? updatedUser : user);
      state.isUpdating[updatedUser._id] = false;
    },
    [updateUser.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = false;
    },

    [disableUsers.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      state.users = currentState.users.map((user) => ids.includes(user._id) ? { ...user, isDisabled: true } : user);
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    },

    [enableUsers.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      state.users = currentState.users.map((user) => ids.includes(user._id) ? { ...user, isDisabled: false } : user);
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    },

    [deleteUsers.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      state.users = currentState.users.filter(({ _id }) => !ids.includes(_id));
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    }
  }
});

export const { setCurrentPage } = usersSlice.actions;

export default usersSlice.reducer;
